var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTumblr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tumblr_clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.29241 2.43315C8.18361 1.17106 10.4067 0.498309 12.6803 0.500003C15.7244 0.505099 18.6424 1.71663 20.7949 3.86916C22.9475 6.02174 24.1591 8.93981 24.1641 11.984C24.1657 14.2576 23.493 16.4806 22.2309 18.3717C20.9688 20.2629 19.174 21.7373 17.0737 22.6082C14.9734 23.4792 12.662 23.7075 10.4318 23.2643C8.20173 22.8212 6.15318 21.7264 4.54542 20.1187C2.93766 18.5109 1.84294 16.4624 1.39978 14.2323C0.956627 12.0021 1.18495 9.69068 2.05587 7.59036C2.92679 5.49005 4.40116 3.69528 6.29241 2.43315Z",
    fill: "#001935",
    stroke: "#244366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6124 14.6827C13.6124 15.764 14.1568 16.1387 15.0271 16.1387H16.2644V18.8917H13.9259C11.8229 18.8917 10.2552 17.8104 10.2552 15.221V11.0793H8.3465V8.83561C10.4525 8.2896 11.3274 6.4818 11.4299 4.91565H13.6124V8.4716H16.1589V11.0717H13.6124V14.6827Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tumblr_clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23.9832,
    fill: "white",
    transform: "translate(0.664062)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTumblr);
export default __webpack_public_path__ + "static/media/tumblr.f7d128e388d73859d9fe15ff88cfd0e8.svg";
export { ForwardRef as ReactComponent };